// EntraAuthButtons.js
import { Form, Button, Col, Row } from 'react-bootstrap';
import microsoftLogo from 'assets/img/logos/microsoft.png';
//import { useAuth } from 'hooks/useAuth'; // Import the useAuth hook
import { useAuth } from 'hooks/useAuth';

const EntraAuthButtons = () =>
{
  const { account, login, logout, accessToken } = useAuth(); // Access account, login, and logout from AuthProvider
  return (
    <Form.Group className="mb-0">
      <Row>
        <Col sm={12} className="ps-sm-3">
          <Button
            variant=""
            size="sm"
            className="btn-outline-microsoft mt-2 w-100"
            onClick={login} // Trigger login when clicked
          >
            <img
              src={microsoftLogo}
              alt="Microsoft"
              className="me-2"
              style={{ width: '20px' }}
            />
            Microsoft
          </Button>
        </Col>
      </Row>
    </Form.Group>
  );
};

export default EntraAuthButtons;
